import { Navigate, Route, Routes } from 'react-router-dom'
import { AppShell } from './components/AppShell'
import { NotFound } from './components/NotFound'
import { SignIn } from './components/SignIn'
import { CountsProvider } from './hooks/useCounts'
import { useAuth } from './hooks/useAuth'
import { AwardsView } from './features/awards/AwardsView'
import { DashboardView } from './features/dashboard/DashboardView'
import { Dcfh2View } from './features/dcfh2/Dcfh2View'
import { PipelineView } from './features/pipeline/PipelineView'
import { ScanView } from './features/scan/ScanView'

export function App() {
  const { me, loading } = useAuth()

  if (loading) {
    return (
      <div className="boot">
        <div className="ring" />
      </div>
    )
  }

  // Everything behind the shell requires a live session; there is no anonymous view of the app.
  if (!me?.authenticated) return <SignIn />

  return (
    <CountsProvider>
      <AppShell>
        <Routes>
          <Route path="/" element={<Navigate to="/opportunities" replace />} />
          <Route path="/opportunities" element={<DashboardView />} />
          <Route path="/pipeline" element={<PipelineView />} />
          <Route path="/dcfh2" element={<Dcfh2View />} />
          <Route path="/awards" element={<AwardsView />} />
          <Route path="/scan" element={<ScanView />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AppShell>
    </CountsProvider>
  )
}
